module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "page-sidebar",
    attrs: {
      "data-pages": "sidebar"
    }
  }, [_c('div', {
    staticClass: "sidebar-menu"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_c('li', {
    staticClass: "open active padtopbottom"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', {
    staticClass: "hide_after_click"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lms.courses'
      }
    }
  }, [_vm._v("Courses")]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('li', {
    staticClass: "hide_after_click"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lms.reports'
      }
    }
  }, [_vm._v("Reports")]), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('li', {
    staticClass: "hide_after_click"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lms.setting'
      }
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('li', {
    staticClass: "hide_after_click"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lms.emaillogs'
      }
    }
  }, [_vm._v("Logs")]), _vm._v(" "), _vm._m(4)], 1), _vm._v(" "), _c('li', {
    staticClass: "hide_after_click"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lms.learningpath'
      }
    }
  }, [_vm._v("Learning Path")]), _vm._v(" "), _vm._m(5)], 1), _vm._v(" "), (_vm.canApproveWorkspace) ? _c('li', {
    staticClass: "hide_after_click"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lms.approvals'
      }
    }
  }, [_vm._v("Approvers Workspace")]), _vm._v(" "), _vm._m(6)], 1) : _vm._e(), _vm._v(" "), (_vm.canCreateWorkspace) ? _c('li', {
    staticClass: "hide_after_click"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lms.creatorapprovals'
      }
    }
  }, [_vm._v("Creators Workspace")]), _vm._v(" "), _vm._m(7)], 1) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lmsSidebarHeader"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("LMS")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarCollapse",
    attrs: {
      "aria-label": "Pin Menu",
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "pg-icon"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-book"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-file-alt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-cog"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-list"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fa fa-user-graduate"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-clipboard-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-user-edit"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b1cc6b8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/sidebar.vue
// module id = 1169
// module chunks = 23